<tt-page *ngIf="!!edit">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input ttLabel="code" [(ttModel)]="edit.code"></tt-input>
        <tt-input ttLabel="platetype" [(ttModel)]="edit.platetype"></tt-input>
    </tt-card>
</tt-page>

<!--<tt-page class="col-xs-12 sp-0">
    <tt-card class="col-xs-12 col-md-4 sp-0">
        <tt-input class="col-xs-12 sp-0" tt-label="code" tt-model="vm.model.edit.code" tt-change="vm.model.edit.code = $value" tt-readonly="false"></tt-input>
        <tt-input class="col-xs-12 sp-0" tt-label="platetype" tt-model="vm.model.edit.platetype" tt-change="vm.model.edit.platetype = $value" tt-readonly="false"></tt-input>
        <tt-search tt-label="prod_id_edge"
                   tt-min-length="2"
                   tt-model="vm.model.edit.prod_id_edge"
                   tt-search="vm.edgeSearch(value, 'prod_id')"
                   tt-search-id="edge_keyno"
                   tt-search-name="edge_keyno"
                   tt-on-selected="vm.edgeSelectItem($item, $modelId)">
        </tt-search>
        <tt-search tt-label="prod_name_edge"
                   tt-min-length="3"
                   tt-model="vm.model.edit.prod_name_edge"
                   tt-search="vm.edgeSearch(value, 'prod_name')"
                   tt-search-id="edge_name"
                   tt-search-name="edge_name"
                   tt-on-selected="vm.edgeSelectItem($item, $modelId)">
        </tt-search>
        <tt-search tt-label="prod_id_plate"
                   tt-min-length="2"
                   tt-model="vm.model.edit.prod_id_plate"
                   tt-search="vm.plateSearch(value, 'prod_id')"
                   tt-search-id="plate_keyno"
                   tt-search-name="plate_keyno"
                   tt-on-selected="vm.plateSelectItem($item, $modelId)">
        </tt-search>
        <tt-search tt-label="prod_name_plate"
                   tt-min-length="3"
                   tt-model="vm.model.edit.prod_name_plate"
                   tt-search="vm.plateSearch(value, 'prod_name')"
                   tt-search-id="plate_name"
                   tt-search-name="plate_name"
                   tt-on-selected="vm.plateSelectItem($item, $modelId)">
        </tt-search>
        <tt-button-save class="col-xs-12 sp-0" tt-text="save" tt-locked="vm.model.lockedSave" tt-click="vm.saveChanges()" tt-text-align="center"></tt-button-save>
        <tt-button ng-if="vm.model.edgeRelationKeyno > 0" class="col-xs-12 sp-0" tt-text="delete" tt-locked="vm.model.lockedDelete" tt-click="vm.delete()" tt-icon="fas fa-trash-alt" tt-type="danger" tt-text-align="center"></tt-button>
    </tt-card>
</tt-page>-->
